import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { VersionDisplayComponent } from './version-display.component'
import { MatMenuModule } from '@angular/material/menu'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { RouterModule } from '@angular/router'

@NgModule({
  declarations: [VersionDisplayComponent],
  imports: [CommonModule, RouterModule, MatMenuModule, FontAwesomeModule],
  exports: [VersionDisplayComponent],
})
export class VersionDisplayModule {}
